import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

export type ConfirmDialogType = 'confirm' | 'delete';

export interface ConfirmDialogState {
  readonly visible: boolean;
  readonly title: string;
  readonly message: string;
  readonly type: ConfirmDialogType;
}

const defaultState: ConfirmDialogState = {
  visible: false,
  title: 'Подтверждение',
  message: 'Вы уверены?',
  type: 'delete',
};

@Injectable({
  providedIn: 'root',
})
export class ConfirmService {
  private readonly dialogState = new BehaviorSubject<ConfirmDialogState>(defaultState);
  private responseSubject = new Subject<boolean>();

  openDialog(
    title: string,
    message: string,
    type: ConfirmDialogType = 'delete',
  ): Observable<boolean> {
    this.responseSubject = new Subject<boolean>();
    this.dialogState.next({
      visible: true,
      title,
      message,
      type,
    });

    return this.responseSubject.asObservable();
  }

  closeDialog(): void {
    this.dialogState.next({
      ...defaultState,
      visible: false,
    });
  }

  confirm(): void {
    this.responseSubject.next(true);
    this.responseSubject.complete();
    this.closeDialog();
  }

  cancel(): void {
    this.responseSubject.next(false);
    this.responseSubject.complete();
    this.closeDialog();
  }

  getDialogState(): Observable<ConfirmDialogState> {
    return this.dialogState.asObservable();
  }
}
